import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  existingServices: localStorage.getItem("existingServices")
    ? JSON.parse(localStorage.getItem("existingServices"))
    : [],
  listServices: localStorage.getItem("listServices")
    ? JSON.parse(localStorage.getItem("listServices"))
    : [],
  listLevels: localStorage.getItem("listLevels")
    ? JSON.parse(localStorage.getItem("listLevels"))
    : [],
  isDisplaySidebar: false,
  isDisplayGraph: localStorage.getItem("isDisplayGraph")
    ? JSON.parse(localStorage.getItem("isDisplayGraph"))
    : false,
  startResearch: false,
  count: false
};

export const displayOptions = createSlice({
  name: "display",
  initialState,
  reducers: {

    clearTarget(state, action) {
        state.listLevels = [];
        state.listServices = [];
        state.isDisplayGraph = false;
        state.startResearch = false;

        localStorage.setItem("listLevels", JSON.stringify(state.listLevels))
        localStorage.setItem("listServices", JSON.stringify(state.listServices))
        localStorage.setItem("isDisplayGraph", JSON.stringify(state.isDisplayGraph))
        localStorage.setItem("startResearch", JSON.stringify(state.startResearch))
    },

    addToListServices(state, action) {
        let tempList = { app: action.payload, indexInList: state.listServices.length};
        state.listServices.push(tempList);
        localStorage.setItem("listServices", JSON.stringify(state.listServices))
    },

    removeToListServices(state, action) {
        const updatedList = state.listServices.filter(
            (item) =>item.indexInList !== action.payload.indexinList
        )
        state.listServices = updatedList;
        localStorage.setItem("listServices", JSON.stringify(state.listServices))
    },

    clearListServices(state, action) {
        state.listServices = [];
        localStorage.setItem("listServices", [])
    },

    addToListLevels(state, action) {
        let tempList = { lvl: action.payload, indexInList: state.listLevels.length};
        state.listLevels.push(tempList);
        localStorage.setItem("listLevels", JSON.stringify(state.listLevels))
    },

    removeToListLevel(state, action) {
        const updatedList = state.listLevels.filter(
            (item) =>item.indexInList !== action.payload.indexinList
        )
        state.listLevels = updatedList;
        localStorage.setItem("listLevels", JSON.stringify(state.listLevels))
    },

    clearListLevels(state, action) {
        state.listLevels = [];
        localStorage.setItem("listLevels", [])
    },

    setIsDisplaySidebar(state, action) {
      state.isDisplaySidebar = action.payload;
      localStorage.setItem("isDisplaySidebar", JSON.stringify(state.isDisplaySidebar));
    },

    setIsDisplayGraph(state, action) {
      state.isDisplayGraph = action.payload;
      localStorage.setItem("isDisplayGraph", state.isDisplayGraph);
    },

    setStartResearch(state, action) {
      state.startResearch = action.payload;
      localStorage.setItem("startResearch", JSON.stringify(state.startResearch));
    },

    setExistingServices(state, action) {
      state.existingServices = action.payload;
      localStorage.setItem("existingServices", JSON.stringify(state.existingServices));
    },

    setCount(state, action) {
      state.count = action.payload;
      localStorage.setItem("count", JSON.stringify(state.count));
    }
  },

});

export default displayOptions.reducer;
export const {
    clearTarget,
    addToListServices,
    removeToListServices,
    clearListServices,
    addToListLevels,
    removeToListLevels,
    clearListLevels,
    setIsDisplaySidebar,
    setIsDisplayGraph,
    setStartResearch,
    setExistingServices,
    setCount
} = displayOptions.actions;
export const displaySelector = (state) => state.display;

